"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutSortViewItems = void 0;
const getLayoutSortViewItems = (layout, api) => {
    var _a;
    const columnIdToFriendlyName = (columnId) => {
        return api.columnApi.getFriendlyNameForColumnId(columnId);
    };
    return {
        name: 'Sort',
        values: ((_a = layout.ColumnSorts) !== null && _a !== void 0 ? _a : []).map((customSort) => `[${columnIdToFriendlyName(customSort.ColumnId)}: ${customSort.SortOrder}]`),
    };
};
exports.getLayoutSortViewItems = getLayoutSortViewItems;
